/* eslint-disable  */
import React from 'react';
import { Table, Header as SemHeader } from 'semantic-ui-react';
import range from 'lodash/range';

const styles = {
    root: {
        padding: '15px'
    },
    headerCell: {
        padding: '0.5em 0.5em'
    },
    cell: {
        padding: '0.5em 0.5em'
    },
    cellAlt: {
        padding: '0.5em 0.5em',
        fontSize: '15px'
    },
    unitCell: {
        backgroundColor: '#CCC0DA',
        padding: '0px',
        margin: '0px'
    },
    unitCellAlt: {
        // backgroundColor: '#72A0C1',
        backgroundColor: '#CCC0DA',
        // leftPadding: '1em',
        // rightPadding: '1em',
        padding: '0.25em 0.25em',
        fontWeight: 'bold',
        fontSize: '15px'
    }
};

export const colors = {
    'Occupied': '#B0E0E6',
    'On Notice': '#F8DE7E',
    'Leased': '#CCFFCC',
    'Vacant': '#fff'
};

export const filterObject = (object, expression) => {

    const rgx = new RegExp(expression, 'i');

    return Object.fromEntries(
        Object.entries(object).filter(([key, value]) => rgx.test(key))
    );
};

export const Title = props => {

    const { data, title } = props;

    const styles = {
        root: {
            position: 'relative',
            height: '75px',
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center'
        },
        table: {
            position: 'absolute',
            right: 0,
            top: 10
        }
    };

    return (
        <div style={styles.root}>
            <SemHeader as='h2' textAlign='center' content={title} />
            {data && <span style={styles.table}><SummaryTable data={data} /></span>}
        </div>
    );
};

export const SummaryTable = props => {

    const { data } = props;

    const initialValue = {
        'Occupied': 0,
        'On Notice': 0,
        'Leased': 0,
        'Vacant': 0
    };


    const counted = data.reduce((acc, unit) => {
        acc[unit.status]++;

        return acc;
    }, initialValue);

    return (
        <Table collapsing compact celled>
            <Table.Body>
                <Table.Row>
                    <Table.Cell content={counted['Occupied']} />
                    <Table.Cell content={'Occupied'} style={{ backgroundColor: colors.Occupied }} />
                    <Table.Cell content={counted['On Notice']} />
                    <Table.Cell content={'On Notice'} style={{ backgroundColor: colors['On Notice'] }} />
                </Table.Row>
                <Table.Row>
                    <Table.Cell content={counted['Leased']} />
                    <Table.Cell content={'Leased'} style={{ backgroundColor: colors.Leased }} />
                    <Table.Cell content={counted['Vacant']} />
                    <Table.Cell content={'Vacant'} style={{ backgroundColor: colors.Vacant }} />
                </Table.Row>

            </Table.Body>
        </Table>
    );
};

export const Header = props => <Table.HeaderCell textAlign='center' style={{
    ...styles.headerCell,
    ...(props.style || {})
}} {...props} />;

export const Cell = props => (
    <React.Fragment>
        <Table.Cell
            collapsing
            style={styles.unitCell}
            content={props.unit}
        />
        <Table.Cell
            textAlign='center'
            style={{
                padding: '0px',
                margin: '0px',
                backgroundColor: colors[props.status]
            }}
            content={props.price}
        />
    </React.Fragment>
);
export const CellAlt = props => (
    <React.Fragment>
        <Table.Cell
            collapsing
            style={styles.unitCellAlt}
            content={props.unit}
        />
        <Table.Cell
            textAlign='center'
            style={{
                ...styles.cellAlt,
                backgroundColor: colors[props.status]
            }}
            content={props.price}
        />
    </React.Fragment>
);

export const EmptyCell = ({ count }) => {

    if (count) {
        return (
            <React.Fragment>
                {range(0, count).map(i => (
                    <React.Fragment key={i}>
                        <Table.Cell style={styles.cell} />
                        <Table.Cell style={styles.cell} />
                    </React.Fragment>
                ))}
            </React.Fragment>
        );
    }

    else {
        return (
            <React.Fragment>
                <Table.Cell style={styles.cell} />
                <Table.Cell style={styles.cell} />
            </React.Fragment>
        );

    }

};


export const renderPrice = (unit, matrixType, noTransform = false) => {

    console.log('are you running????')
    console.log(unit)

    if (!unit) {
        return 'N/A';
    }

    const { amenityRent, marketRent, currentRent } = unit;

    let price;

    switch (matrixType) {
        case 'market':
            price = marketRent + amenityRent;
            break;
        case 'current':
            price = currentRent ? currentRent : 0;
            break;

        default:
            price = marketRent + amenityRent;
            break;
    }


    return noTransform ? price : `$${price}`;
};


export const createDualColHeaders = contentArray => contentArray.map(content => (
    <Header colSpan='2' content={content} />
));
